export enum EField {
    none = 'none',

    registrationCheckPostCode = 'registrationCheckPostCode',
    registrationCheckPostCodeLoqate = 'registrationCheckPostCodeLoqate',
    registrationBillingAddress = 'registrationBillingAddress',
    registrationBoxQuantity = 'registrationBoxQuantity',
    registrationBoxFrequency = 'registrationBoxFrequency',
    registrationTerms = 'registrationTerms',
    registerDiscount = 'registerDiscount',
    registerDiscountV2 = 'registerDiscountV2',
    subscriptionDeliveryConfig = 'subscriptionDeliveryConfig',
    email = 'email',
    loginPassword = 'loginPassword',
    password = 'password',
    confirmPassword = 'confirmPassword',
    customerWantReceiveNewsletters = 'customerWantReceiveNewsletters',
    customerCommunicationChannels = 'customerCommunicationChannels',

    sameBillingAddress = 'sameBillingAddress',

    billingAddress = 'billingAddress',

    customerId = 'customerId',
    customerFirstName = 'customerFirstName',
    customerLastName = 'customerLastName',
    customerPostCode = 'customerPostCode',
    customerPhoneNumber = 'customerPhoneNumber',
    customerSafePlaceDescription = 'customerSafePlaceDescription',
    customerRole = 'customerRole',
    registrationCustomerAllergies = 'registrationCustomerAllergies',
    customerAllergies = 'customerAllergies',
    customerMarketingContent = 'customerMarketingContent',
    customerWhat3wordsAddress = 'customerWhat3wordsAddress',

    productDescription = 'productDescription',
    productIsActive = 'productIsActive',
    productName = 'productName',
    productPrice = 'productPrice',
    productCategory = 'productCategory',
    productImageUrl = 'productImageUrl',
    productPortion = 'productPortion',
    productPosition = 'productPosition',
    productExcludedFromGlobalAddonLimit = 'productExcludedFromGlobalAddonLimit',

    exclusionName = 'exclusionName',
    exclusionLegacyName = 'exclusionLegacyName',
    exclusionCode = 'exclusionCode',
}
